import React, { Component } from 'react'
import "video-react/dist/video-react.css"
import { Player, ControlBar, BigPlayButton, PlaybackRateMenuButton } from 'video-react';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Check from "@material-ui/icons/Check"; 
import styles from "./styles.scss";
import cx from "classnames";
import { get } from "lodash";
import { string, objectOf, number, oneOfType, object, array, bool } from 'prop-types';
import images from "../../../resources/images";
import Slide from '@material-ui/core/Slide';
import { getMediaBoundariesForMention } from "../../../../client/src/helpers/mediaBoundaryService";
import _ from "lodash";
import { connect } from "react-redux";
import addSeconds from 'date-fns/add_seconds';
import moment from "moment";
import veritoneApi from '../../helpers/veritoneApi';

const styleMedia = theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  fabProgress: {
    color: "#A0C5F0",
    position: 'absolute',
    top: '50%',
    left: '50%',
    zIndex: 1,
    marginLeft: '-37px',
    marginTop: '-37px'
  },
});

const ADDING_DURATION_TIME = 30 // seconds;
const TIME_TO_ADD_DURATION_AFTER_CLICK = 2 //seconds;
const TIME_TO_CHANGE_STATE = 2050 //miliseconds;
const AUDIO = 1;
const TIME_TO_HIDDEN_BUTTON = 500;

  @connect(state => ({
    organization: state.user.user.organization,
    config: state.config
  }))
class PlayerMedia extends Component {
  static propTypes = {
    classes: objectOf(string),
    mediaMention: objectOf(oneOfType([string, number, object, array, bool])),
    config: objectOf(oneOfType([string, number])),
    organization: objectOf(oneOfType([string, number]))
  }

  state = {
    isShowLeft: false,
    isShowRight: false,
    clickNumberRight: 0,
    clickNumberLeft: 0,
    clickTime: 0,
    isChangeState: false,
    currentStartTime: "",
    currentStopTime: "",
    isChangeDuration: false,
    mediaSource: "",
    currentTimeMedia: 0,
    hiddenButton: false,
    isLoadSuccess: false
  }

  async componentDidMount() {
    window.addEventListener("keydown", this.handleKeyDown);
    const { mediaMention, config, organization } = this.props;
    const { programId, station_id, airtime } = mediaMention;
    const programLiveImage = await this.getProgramImage(programId);
    const defaultTime = getMediaBoundariesForMention({ mention: mediaMention, organization });
    const currentTimeMedia = ((new Date(airtime)).getTime() - (new Date(defaultTime.start)).getTime())/1000;
    const mediaSource = `${config.apiRoot}/media-streamer/mediasource/${station_id}/programId/${programId}?startDate=${defaultTime.start}&endDate=${defaultTime.end}`;
    // eslint-disable-next-line
    this.setState({
      currentStartTime: defaultTime.start,
      currentStopTime: defaultTime.end,
      mediaSource,
      currentTimeMedia,
      programLiveImage
    })
  }
 
  componentDidUpdate(prevProps, prevState) {
    const currrentTime = (new Date()).getTime();
    const {
      isShowLeft,
      isShowRight,
      clickNumberLeft,
      clickNumberRight,
      isLoadSuccess,
      clickTime
    } = this.state;
    const { clickNumberRight: prevClickNumberRight, clickNumberLeft: prevClickNumberLeft } = prevState;
    const player = this.player && get(this.player.getState(), "player");
    if (!isLoadSuccess && prevClickNumberLeft > 0 && isShowLeft) {
      //after 2 seconds after clicking the button of the left, revoke adding duration
      const isChangeTimeLeft =  (currrentTime - clickTime)/1000 > TIME_TO_ADD_DURATION_AFTER_CLICK;
      const isChangeClickNumberLeft = (prevClickNumberLeft - clickNumberLeft) !== prevClickNumberLeft;
      if (isChangeTimeLeft && isChangeClickNumberLeft) {
        // eslint-disable-next-line
        this.setState({
          isChangeDuration: true
        })
        setTimeout(
          this.addDurationMedia({left: true, numberClick: prevClickNumberLeft, currentTimeMedia: player.currentTime + ADDING_DURATION_TIME * prevClickNumberLeft}),
          TIME_TO_ADD_DURATION_AFTER_CLICK * 1000
        )
      }
    }
    if (isLoadSuccess && isShowRight && JSON.stringify(prevState) !== JSON.stringify(this.state)) {
        this.setHiddenRightButton();
    }
    if (isLoadSuccess && isShowLeft && JSON.stringify(prevState) !== JSON.stringify(this.state)) {
        this.setHiddenLeftButton();
    }

    if (!isLoadSuccess && prevClickNumberRight > 0 && isShowRight) {
      //after 2 seconds after clicking the button of the left, revoke adding duration
      const isChangeTimeRight = (currrentTime - clickTime)/1000 > TIME_TO_ADD_DURATION_AFTER_CLICK;
      const isChangeClickNumberRight = (prevClickNumberRight - clickNumberRight) !== prevClickNumberRight;
      if (isChangeTimeRight && isChangeClickNumberRight) {
        // eslint-disable-next-line
        this.setState({
          isChangeDuration: true
        })
        setTimeout(
          this.addDurationMedia({right: true, numberClick: prevClickNumberRight, currentTimeMedia: player.currentTime}),
          TIME_TO_ADD_DURATION_AFTER_CLICK * 1000
        )
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener("keydown", this.handleKeyDown);
  }

  //get programImage from graphQL call through server
  getProgramImage(programId) {
    const { config } = this.props;
    return veritoneApi(config.urlApi.baseUrl)
    .get(`/campaign/getProgramLiveImage/${programId}`)
    .then(response => {
      return _.get(response, 'data.programLiveImage');
    })
    .catch(error => error);
  }

  handleForWard = () => {
    const { clickNumberRight } = this.state;
    setTimeout(() => {
      this.setState(state => ({
        isChangeState: !state.isChangeState
      }))
    }, TIME_TO_CHANGE_STATE)
    if(clickNumberRight > 9) {
      return ;
    }
    this.setState(state => ({
      clickTime: (new Date()).getTime(),
      clickNumberRight: state.clickNumberRight + 1
    }));
    this.setLoading()
  }

  handleReplay = () => {
    setTimeout(() => {
      this.setState(state => ({
        isChangeState: !state.isChangeState
      }))
    }, TIME_TO_CHANGE_STATE)
    const { clickNumberLeft } = this.state;
    if(clickNumberLeft > 9) {
      return ;
    }
    this.setState(state => ({
      clickTime: (new Date()).getTime(),
      clickNumberLeft: state.clickNumberLeft + 1
    }));
    this.setLoading()
  }

  handleKeyDown = event => {
    const { player } = this.player.getState();
    //event press SHIFT -> or W 
    if ((event.shiftKey && event.keyCode === 39) || event.keyCode === 87) {
      event.preventDefault();
      const playbackRate = player.playbackRate;
      if(playbackRate === 0.1) {
        this.player.playbackRate = 0.5;
      }
      if(playbackRate === 0.5) {
        this.player.playbackRate = 1;
      }
      if(playbackRate === 1) {
        this.player.playbackRate = 2;
      }
      if(playbackRate >= 2) {
        this.player.playbackRate = 5;
      }
    }
    //event press SHIFT <- or S 
    if ((event.shiftKey && event.keyCode === 37) || event.keyCode === 83) {
      const playbackRate = player.playbackRate;
      if(playbackRate === 5) {
        this.player.playbackRate = 2;
      }
      if(playbackRate === 2) {
        this.player.playbackRate = 1;
      }
      if(playbackRate === 1) {
        this.player.playbackRate = 0.5;
      }
      if(playbackRate <= 0.5) {
        this.player.playbackRate = 0.1;
      }
    }
    // event press SPACE
    if (event.keyCode === 32) {
      event.preventDefault();
      player.paused ? this.player.play() : this.player.pause();
    }
    //event press <- or A 
    if ((!event.shiftKey && event.keyCode === 37) || event.keyCode === 65) {
      event.preventDefault();
      this.addDurationMedia({left: true, numberClick: 1, currentTimeMedia: player.currentTime + ADDING_DURATION_TIME});
    }
    //event press -> or D
    if ((!event.shiftKey && event.keyCode === 39) || event.keyCode === 68) {
      event.preventDefault();
      this.addDurationMedia({right: true, numberClick: 1, currentTimeMedia: player.currentTime})
    }
  }

  hoverLeft = () => {
    this.setState({
      isShowLeft: true,
      isShowRight: false
    })
  }

  handleMouseOutLeft = () => {
    this.setLoading();
    this.setState({
      isShowLeft: false,
      clickNumberLeft: 0
    })
  }

  handleMouseOutRight = () => {
    this.setLoading();
    this.setState({
      isShowRight: false,
      clickNumberRight: 0
    })
  }

  hoverRight = () => {
    this.setState({
      isShowRight: true,
      isShowLeft: false
    })
  }

  initPlayerRef = el => {
    this.player = el;
  };

  setHidden = () => {
    this.setState({
      hiddenButton: false
    })
  }
  
  setHiddenRightButton = () => {
    setTimeout(() => {
      this.setState({
        hiddenButton: true
      })
    }, TIME_TO_HIDDEN_BUTTON)
  }

  setHiddenLeftButton = () => {
    setTimeout(() => {
      this.setState({
        hiddenButton: true
      })
    }, TIME_TO_HIDDEN_BUTTON)
  }

  addDurationMedia = (position) => {
    const { config } = this.props;
    let {
      currentStartTime,
      currentStopTime,
      currentTimeMedia,
      mediaSource,
      isLoadSuccess
    } = this.state;
    let isLoad = isLoadSuccess;
    const { mediaMention } = this.props;
    const { station_id, programId } = mediaMention;
    const { numberClick } = position;
    if (position.left) {
      currentStartTime = this.getChangeTime(currentStartTime, numberClick * (-30));
      mediaSource = `${config.apiRoot}/media-streamer/mediasource/${station_id}/programId/${programId}?startDate=${currentStartTime}&endDate=${currentStopTime}`;
      isLoad = true;
    }
    if(position.right) {
      currentStopTime = this.getChangeTime(currentStopTime, numberClick * 30);
      mediaSource =  `${config.apiRoot}/media-streamer/mediasource/${station_id}/programId/${programId}?startDate=${currentStartTime}&endDate=${currentStopTime}`;
      isLoad = true;
    }
    this.setState({
      isLoadSuccess: isLoad,
      currentTimeMedia: position ? position.currentTimeMedia : currentTimeMedia,
      currentStartTime,
      currentStopTime,
      mediaSource,
      isChangeDuration: false
    });
  }

  getChangeTime = (time, seconds) => {
    const timeChange = addSeconds(new Date(time), seconds);
    const timeFormat = moment.utc(timeChange).format('YYYY-MM-DDTHH:mm:ss.SSS');
    return `${timeFormat}Z`;
  }

  setLoading = () => {
    this.setState({
      isLoadSuccess: false,
      hiddenButton: false
    });
  }

  render() {
    const {
      isShowLeft,
      isShowRight,
      clickNumberRight,
      clickNumberLeft,
      isChangeDuration,
      mediaSource,
      currentTimeMedia,
      hiddenButton,
      isLoadSuccess,
      programLiveImage
    } = this.state;
    const {
      classes,
      mediaMention
    } = this.props;
    const isAudio = mediaMention && mediaMention.mediaSourceTypeId === AUDIO;
    const textLeft = clickNumberLeft === 1 ||   (clickNumberLeft === 0 && !isChangeDuration) ? "+30s" : `+${clickNumberLeft * 30 / 60}m`;
    const textRight = clickNumberRight === 1 || (clickNumberRight === 0 && !isChangeDuration) ?  "+30s" : `+${clickNumberRight * 30 / 60}m`;

    return (
      <div className={isAudio ? cx(styles["box-audio"]) : cx(styles["box-video"])}>
        <div className={cx(styles["increase-box"])} onMouseOver={this.hoverLeft} onMouseLeave={this.handleMouseOutLeft}>
            <Slide 
              in={isShowLeft}
              timeout={500}
              direction="left"
              >
                <span className={cx(styles["increase-button-box"])}>
                    { isShowLeft && !hiddenButton && 
                        <Button color="primary" className={cx(styles["increase-button"])} onClick={this.handleReplay}>
                            {isLoadSuccess && <Check className={cx(styles["check-option"])}/> }
                            {!isLoadSuccess && <span className={cx(styles["increase-text"])}>{textLeft}</span>}
                        </Button>
                    }
                    {!isLoadSuccess && isShowLeft && clickNumberLeft > 0 && <CircularProgress size={75} className={classes.fabProgress} />}
                </span>
            </Slide>
        </div>
        <div className={cx(styles["media-box"])} onMouseOver={this.setHidden}>
          {mediaSource &&
            <Player 
              src={mediaSource}
              ref={this.initPlayerRef}
              fluid={false}
              width={"100%"}
              height={"426px"}
              startTime={currentTimeMedia}
              poster={programLiveImage ? programLiveImage : images.defaultMediaImage}
              className={cx({
                'video-react-control-bar-auto-hide': true }, styles["media-player"])}           
              aspectRatio="16:9"
              preLoad={"none"}
            >
              <BigPlayButton position="center" />
                <ControlBar 
                  autoHide={false}
                  className={cx(styles['control-bar'])}
                > 
                <PlaybackRateMenuButton rates={[5, 2, 1, 0.5, 0.1]} />
              </ControlBar>
            </Player>
          }
        </div>
        <div className={cx(styles["increase-box"])} onMouseOver={this.hoverRight} onMouseLeave={this.handleMouseOutRight}>
          { 
            <Slide 
              in={isShowRight}
              timeout={500}
              direction="right"
            >
              <span className={styles["increase-button-box"]}>
                { isShowRight && !hiddenButton &&
                    <Button className={cx(styles["increase-button"])} color="primary" onClick={this.handleForWard} size="medium">
                        {isLoadSuccess && <Check className={cx(styles["check-option"])} />}
                        {!isLoadSuccess && <span className={cx(styles["increase-text"])}>{textRight}</span>}
                    </Button>
                }
                {!isLoadSuccess && isShowRight && clickNumberRight > 0 && <CircularProgress size={75} className={classes.fabProgress} />}
              </span>
            </Slide>
            }
        </div>
      </div>
    )
  }
}

export default  withStyles(styleMedia)(PlayerMedia);
